import { getDefaultImage, TypeDefaultImage } from "@/lib/image";
import { Attachment } from "@/lib/types";
import { Badge } from "../ui/badge";

export const TextCell = ({ value }: { value: string }) => {
  return (
    <div className="flex items-center gap-2 text-wrap font-['Raleway']">
      <p className="text-[14px] font-[500]">{value}</p>
    </div>
  );
};

export const ImageTextCell = ({
  value,
  attachments,
  domain,
}: {
  value: string;
  attachments: Attachment[];
  domain: TypeDefaultImage;
}) => {
  const image = getDefaultImage(attachments, domain, "publicUrl");
  return (
    <div className="flex items-center gap-3 text-wrap">
      {image && (
        <img
          src={image}
          alt="oeuvre"
          className="size-0 aspect-square object-contain"
        />
      )}
      <p className="text-[14px] font-[500] font-['Raleway']">{value}</p>
    </div>
  );
};

export const ImageCell = ({
  attachments,
  domain,
}: {
  value: string;
  attachments: Attachment[];
  domain: TypeDefaultImage;
}) => {
  const image = getDefaultImage(attachments, domain, "mediumPublicUrl");
  if (!image) {
    return <div className="flex items-center gap-3 text-wrap"></div>;
  }
  return (
    <img
          src={image}
          alt="oeuvre"
          className="size-[70px] aspect-square object-contain"
        />
  );
};

export const BadgeCell = ({
  value,
  variant,
}: {
  value: string;
  variant: "outlined" | "contained" | "published" | "draft";
}) => {
  if (!value) {
    return <div className="flex items-center gap-2 text-wrap"></div>;
  }
  return (
    <div className="flex items-center gap-2 text-wrap">
      <Badge variant={variant}>{value}</Badge>
    </div>
  );
};

export const HtmlCell = ({ value }: { value: string }) => {
  const sanitizedHtml = value
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
    .replace(/on\w+="[^"]*"/g, "")
    .replace(/javascript:[^"']*/g, "")
    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, "");

  return (
    <div className="flex items-center gap-2 text-wrap">
      <div
        className="text-[14px] font-[500] font-['Raleway']"
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    </div>
  );
};
